import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OutputIcon(props: IconProps) {
    return <Icon {...props} iconKey={"output"}/>
}
